import noticesFa from './fa/fa.json'

const noticesMessages = {
  fa: { ...noticesFa },
}

export default noticesMessages
